import { useState } from "react";

export default function ReportModal({ isOpen, onClose, onReport, reportedUserId, chatRoomId }) {
    const [submitting, setSubmitting] = useState(false);
    const [reportReason, setReportReason] = useState("");

    if (!isOpen) return null;

    const handleReport = async () => {
        if (!reportReason) return;
        setSubmitting(true);
        await onReport({
            reported_user: reportedUserId,
            chat_room: chatRoomId,
            reason: reportReason,
        });
        setSubmitting(false);
    };

    return (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white dark:bg-gray-900 py-4 px-4 rounded-lg shadow-lg w-[80%]">
                <h2 className="text-[16px] font-bold text-black dark:text-white mb-2 flex justify-center items-center">
                    Report & Block User
                </h2>
                <p className="text-gray-600 dark:text-gray-500 mb-2 text-[12px] text-center">
                    Please select an option below to either report, block, or both:
                </p>
                <div className="mb-2">
                    <label htmlFor="reportReason" className="text-[12px] text-black dark:text-white font-medium">
                        Reason for Report:
                    </label>
                    <select
                        id="reportReason"
                        value={reportReason}
                        onChange={(e) => setReportReason(e.target.value)}
                        className="block w-full text-[14px] p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-900 rounded-lg text-gray-700 dark:text-white outline-none cursor-pointer"
                    >
                        <option selected disabled>Select a reason</option>
                        <option value="Spam">Spam</option>
                        <option value="Harassment or Bullying">Harassment or Bullying</option>
                        <option value="Hate Speech">Hate Speech</option>
                        <option value="Nudity or Sexual Content">Nudity or Sexual Content</option>
                        <option value="Violence or Threats">Violence or Threats</option>
                        <option value="Other">Other</option>
                    </select>
                </div>

                <div className="flex items-center justify-between gap-4 px-0">
                    <button
                        onClick={onClose}
                        disabled={submitting}
                        className="rounded-full bg-[#151515] dark:bg-[#040404] hover:bg-[#272727] text-[12px] font-bold px-8 h-7 text-white cursor-pointer"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleReport}
                        disabled={!reportReason || submitting}
                        className="rounded-full text-[12px] px-8 h-7 bg-red-500 font-bold hover:bg-red-600 text-white cursor-pointer"
                    >
                        {submitting ? "Reporting..." : "Report"}
                    </button>
                </div>
            </div>
        </div>
    )
}

